import React, { useState } from 'react';
import './App.css';
import { Provider, useSelector } from 'react-redux';
import store, { RootState } from './store';
import NativeProtocolContainer from './NativeProtocolContainer';
import { facebookLogin, getAppVersion, getPurchaseProductList, getWebViewType, googleLogin, kakaoLogin, purchaseProduct, rewardAds } from './NativeProtocolCaller';
import { v4 as uuidv4 } from 'uuid';
import Cookies from 'js-cookie';
import { deleteCookie, getCookie, setCookie } from './common/utility';

function App() {
  const { appVersion, nativeResult, products } = useSelector((state: RootState) => state.global);
  const [activeTab, setActiveTab] = useState('Basic');
  const [localStorageText, setLocalStorageText] = useState('');
  const [cookieText, setCookieText] = useState('');
  const tabs = [
    { name: 'Basic', key: 'Basic' },
    { name: 'Tools', key: 'Tools' },
    // 탭 추가 시 이 배열에 객체 추가
  ];
  
  // ===========================================================================
  // 앱 버전
  // ===========================================================================
  const handleGetAppVersion = (e: React.MouseEvent<HTMLButtonElement>) => {
    console.log("call get app version");
    getAppVersion();
  }

  // ===========================================================================
  // 구글 로그인
  // ===========================================================================
  const handleGoogleLogin = (e: React.MouseEvent<HTMLButtonElement>) => {
    console.log("call google login");
    googleLogin();
  }

  // ===========================================================================
  // 카카오 로그인
  // ===========================================================================
  const handleKakaoLogin = (e: React.MouseEvent<HTMLButtonElement>) => {
    console.log("call kakao login");
    kakaoLogin();
  }

  // ===========================================================================
  // 페이스북 로그인
  // ===========================================================================
  const handleFacebookLogin = (e: React.MouseEvent<HTMLButtonElement>) => {
    console.log("call facebook login");
    facebookLogin();
  }

  // ===========================================================================
  // 리워드 광고 호출
  // ===========================================================================
  const handleRewardAds = (e: React.MouseEvent<HTMLButtonElement>) => {
    console.log("call reward ads");
    rewardAds("ca-app-pub-3940256099942544/1712485313");  // 테스트 광고 단위 ID
  }

  // ===========================================================================
  // 구매 상품 목록 조회
  // ===========================================================================
  const handlePurchaseProductList = (e: React.MouseEvent<HTMLButtonElement>) => {
    console.log("call purchase product list");

    // CashShop에 등록된 상품 아이디 목록
    getPurchaseProductList(products.map((product: any) => product.productId));
  }

  // ===========================================================================
  // 구매 상품 구매 (productId 파라미터로 받음)
  // ===========================================================================
  const handlePurchaseProduct = (productId: string) => {
    console.log("call purchase product", productId);
    const orderId = uuidv4();
    purchaseProduct(productId, orderId);
  }

  return (
    <Provider store={store}>
      <div className="app">
        <header className="app-header">
          <h1 className="app__title">Native Bridge</h1>
          <div className="app__webview-type">{getWebViewType()}</div>
          <div className="app__version">{appVersion}</div>
          <div className="app__version">{nativeResult}</div>
          <div className="app__tab-wrap">
            <div className="app__tabs">
              {tabs.map(tab => (
                <button
                  key={tab.key}
                  className={`app__tab${activeTab === tab.key ? ' app__tab--active' : ''}`}
                  onClick={() => setActiveTab(tab.key)}
                  type="button"
                >
                  {tab.name}
                </button>
              ))}
            </div>
            <div className="app__tab-content">
              {activeTab === 'Basic' && (
                <div className="app__button-wrap">
                  <div className="app__button">
                    <button onClick={handleGetAppVersion}>
                      Get APP Version
                    </button>
                    <button onClick={handleGoogleLogin}>
                      Google Login
                    </button>
                    <button onClick={handleKakaoLogin}>
                      Kakao Login
                    </button>
                    <button onClick={handleFacebookLogin}>
                      Facebook Login
                    </button>
                    <button onClick={handleRewardAds}>
                      Reward Ads
                    </button>
                    <button className="app__button__purchase-btn" onClick={handlePurchaseProductList}>
                      Purchase Product List
                    </button>
                    <div className="app__button__purchase-list">
                      {products.map((product: any) => (
                        <button
                          key={product.productId}
                          className="app__button__purchase-btn"
                          onClick={() => handlePurchaseProduct(product.productId)}
                        >
                          Purchase - {product.productId}
                        </button>
                      ))}
                    </div>
                  </div>
                </div>
              )}
              {activeTab === 'Tools' && (
                <div className="app__button-wrap">
                  {/* Local Storage */}
                  <div className="app__button">
                    <button onClick={() => {
                      const value = 'This is Local Storage Test!';
                      window.localStorage.setItem('test', value);
                      setLocalStorageText('Set Value : ' + value);
                    }}>
                      Set Local Storage
                    </button>
                    <button onClick={() => {
                      const value = window.localStorage.getItem('test');
                      console.log("get local storage", value);
                      setLocalStorageText('Get Value : ' + (value || 'No Value!!!'));
                    }}>
                      Get Local Storage
                    </button>
                    <button onClick={() => {
                      window.localStorage.removeItem('test');
                      setLocalStorageText('Remove Value');
                    }}>
                      Remove Local Storage
                    </button>

                    <div className="app__localstorage-box">
                      {localStorageText}
                    </div>

                    {/* Cookie */}
                    <button onClick={() => {
                      const value = 'This is Cookie Test!';
                      setCookie('test', value);
                      setCookieText('Set Value : ' + value);
                    }}>
                      Set Cookie
                    </button>
                    <button onClick={() => {
                      const value = getCookie('test');
                      console.log("get cookie", value);
                      setCookieText('Get Value : ' + (value || 'No Value!!!'));
                    }}>
                      Get Cookie
                    </button>
                    <button onClick={() => {
                      deleteCookie('test');
                      setCookieText('Remove Value');
                    }}>
                      Remove Cookie
                    </button>

                    <div className="app__localstorage-box">
                      {cookieText}
                    </div>
                    <button onClick={() => {
                      window.location.href = 'https://www.google.com';
                    }}>
                      Go to Google
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </header>
      </div>
      <NativeProtocolContainer />
    </Provider>
  );
}

export default App;
